<section class="page-container">
	
    <div class="container">

        <div class="row mb-4 pb-4">

            <div class="col-12 mb-3">
                <div class="searchCta mb-3">
                    Browse Member Discounts & Perks
                </div>
                <div class="mainSearch">
                    <div class="searchContainer">
                        <div class="searchBox m-100">
                            <input type="search" class="form-control" [(ngModel)]="searchText" placeholder="search our member discounts...">
                            <button type="button" class="btn btn-secondary m-100" (click)="searchDiscounts()">Search</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <label for="discountType" class="form-label">Show Discounts From</label>
                <select (change)="searchDiscounts()" class="form-select form-select-lg mb-3" [(ngModel)]="fromSearch" aria-label="discounts from">
                    <option value="0">Anyone</option>
                    <option value="1">Chamber Members</option>
                    <option value="2">Indy Chamber</option>
                  </select>
            </div>

            <div class="col-md-4">
                <label for="discountStatus" class="form-label">Discount Status</label>
                <select (change)="searchDiscounts()" class="form-select form-select-lg mb-3" [(ngModel)]="statusSearch" aria-label="discounts status">
                    <option value="0">Available to Use</option>
                    <option value="1">Redeemed by Me</option>
                    <option value="2">All</option>
                  </select>
            </div>

        </div>
        <hr />
        <div class="discountListWrap mt-4 row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-1 row-cols-sm-1 g-5">

            <div *ngFor="let discount of discounts" class="col">
                <div class="couponCard card h-100">
                    <img *ngIf="discount.logoUrl != ''" src="{{discount.logoUrl}}" class="couponLogo">
                    <div *ngIf="discount.logoUrl == ''" class="noLogo">{{discount.companyName}}</div>
                    <h3>{{discount.value}}</h3>
                    <div class="couponRow">
                        <a *ngIf="!discount.wasClaimed" class="btn couponBtn" [routerLink]="['/public/claim-member-discount', discount.discountId]">Claim This Offer</a>
                        <span *ngIf="discount.wasClaimed" class="couponRedeemed">You've Already Claimed This Offer</span>
                    </div>
                    <p>{{discount.validThroughString}}</p>
                    <div class="circle1"></div>
                    <div class="circle2"></div>
                </div>
            </div>
        </div>

        
    </div>

    

</section>